import { getLogLevel } from "@/utils/get-log-level";
import { LoggingLevel } from "@/utils/logger/constants";
import { Logger } from "@/utils/logger/types";

const logLevel = getLogLevel();

const errorParams =
  "background-color: #e0005a ; color: #fff ; font-weight: bold ; padding: 4px ;";

const warningParams =
  "background-color: #ffa500 ; color: #000 ; font-weight: bold ; padding: 4px ;";

export const logger: Logger = {
  log: (msg, params) => {
    if (logLevel <= LoggingLevel.All && logLevel !== LoggingLevel.Off) {
      if (params) {
        return window.console.log(msg, params);
      }

      return window.console.log(msg);
    }
  },

  verbose: msg => {
    if (
      (logLevel <= LoggingLevel.Verbose || logLevel !== LoggingLevel.All) &&
      logLevel !== LoggingLevel.Off
    ) {
      return window.console.log(msg);
    }
  },

  information: message => {
    if (
      (logLevel <= LoggingLevel.Information || logLevel !== LoggingLevel.All) &&
      logLevel !== LoggingLevel.Off
    ) {
      return window.console.info(message);
    }
  },

  warning: error => {
    if (
      (logLevel <= LoggingLevel.Warning || logLevel === LoggingLevel.All) &&
      logLevel !== LoggingLevel.Off
    ) {
      return window.console.info(`%c[WARNING] ${error}`, warningParams);
    }
  },

  error: error => {
    if (
      (logLevel <= LoggingLevel.Error || logLevel === LoggingLevel.All) &&
      logLevel !== LoggingLevel.Off
    ) {
      return window.console.error(`%c[ERROR] ${error}`, errorParams);
    }
  },

  critical: (error, params) => {
    if (
      (logLevel <= LoggingLevel.Critical || logLevel === LoggingLevel.All) &&
      logLevel !== LoggingLevel.Off
    ) {
      return window.console.log(`%c[CRITICAL] ${error}`, params ?? errorParams);
    }
  },

  group: (name, params) => window.console.groupCollapsed(name, params ?? ""),

  groupEnd: () => window.console.groupEnd(),
};
